import {createBrowserHistory} from 'history'
import {useSearchParam} from "react-use";

const history = createBrowserHistory()

export default history

export const useRouteSearchParam = useSearchParam

export const getRouteSearchParams = () => {
  return new URLSearchParams(window.location.search);
};
export const copyLocationParam = (location) => {
  return location ?? {}
}
export const getRoutePathParams = () => {
  return window.location.pathname;
};
export const routePathStartsWith = (location, routePathname) => {
  return location?.pathname?.startsWith(routePathname)
}